import Routes from 'flarum/common/extenders/Routes';

/*
 * 🚨 A function returning import(), so the page is a chunk of its own that is
 * fetched only when somebody opens /muster.
 */
export default [new Routes().add('muster', '/muster', () => import(/* webpackChunkName: 'forum/components/WorklistPage', webpackMode: 'lazy-once' */ './components/WorklistPage'))];flarum.reg.addChunkModule('6', '214', 'ernestdefoe-muster', 'forum/components/WorklistPage');
flarum.reg.addChunkModule('6', '214', 'ernestdefoe-muster', 'common/components/Worklist');
flarum.reg.addChunkModule('6', '214', 'ernestdefoe-muster', 'common/worklistCss');